import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AuthLayout from '../components/AuthLayout';
import axios from '../libs/axios';

export default function Signup({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await axios.post('/auth/signup', { email, password, firstName, lastName });
      onLogin(res.data.access_token);
    } catch (err) {
      const msg = err?.response?.data?.detail || err?.message || 'Signup failed';
      setError(msg);
    }
  };

  return (
    <AuthLayout
      title="Create your account"
      subtitle="Start uploading and managing your DATEV documents"
      footer={(<p>Already have an account? <Link className="link" to="/login">Sign in</Link></p>)}
    >
      {error && <div className="alert error">{error}</div>}
      <form onSubmit={handleSubmit} className="form">
        <div className="grid-2">
          <div>
            <label className="label">First name</label>
            <input className="input" type="text" placeholder="Jane" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
          </div>
          <div>
            <label className="label">Last name</label>
            <input className="input" type="text" placeholder="Doe" value={lastName} onChange={(e) => setLastName(e.target.value)} />
          </div>
        </div>
        <label className="label">Email</label>
        <input className="input" type="email" placeholder="you@company.com" value={email} onChange={(e) => setEmail(e.target.value)} />
        <label className="label">Password</label>
        <input className="input" type="password" placeholder="Create a strong password" value={password} onChange={(e) => setPassword(e.target.value)} />
        <button className="btn-primary" type="submit">Create account</button>
      </form>
    </AuthLayout>
  );
}
